import React from 'react';
import ActivityList from 'components/activity-list/activity-list'

const ProjectActivity = (
    {
        currentProject,
    },
) => {
    return (
        <div>
            <ActivityList 
                context="project" 
                projectId={currentProject.id} 
            />
        </div>
    );
};

export default ProjectActivity;



// WEBPACK FOOTER //
// ./src/sections/projects/project/project-activity/project-activity.jsx